import { Paper } from '@mui/material';
import { Box, useMediaQuery, useTheme } from '@mui/system';
import { FormTemplateType } from 'api/models';
import useQuery from 'hooks/useQuery';
import { useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { FormTemplateEditorMode } from 'routes/FormTemplateEditor/FormTemplateEditor';
import FormTemplateTypesTable from 'routes/ProjectFormLists/FormTemplateTypesTable';
import VisitTemplateTable from 'routes/ProjectFormLists/VisitTemplateTable';
import {
  formTemplateTypeListState,
  projectState,
  sampleTemplateTypeListState,
} from 'state';
import { GeneralIds, ModelTypes } from 'types/types';

export default function ProjectFormLists() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isBigScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const isFullWidth = isMobile || isTablet || isBigScreen;
  const { projectId } = useParams<GeneralIds>();
  const [formTemplateTypes, setFormTemplateTypes] = useRecoilState(
    formTemplateTypeListState,
  );
  const [sampleTemplateTypes, setSampleTemplateTypes] = useRecoilState(
    sampleTemplateTypeListState,
  );
  const { selectedProject } = useRecoilValue(projectState);

  const { loading: formTemplateTypesLoading } = useQuery<FormTemplateType[]>({
    type: ModelTypes.formTemplateType,
    queryParams: {
      type: FormTemplateEditorMode.default,
    },
    ids: { projectId: projectId },
    set: {
      data: setFormTemplateTypes,
    },
  });

  const { loading: sampleTemplateTypesLoading } = useQuery<FormTemplateType[]>({
    type: ModelTypes.formTemplateType,
    queryParams: {
      type: FormTemplateEditorMode.sample,
    },
    ids: { projectId: projectId },
    set: {
      data: setSampleTemplateTypes,
    },
  });

  return (
    <Box
      sx={{ mt: 2, pb: 2 }}
      flexDirection={isFullWidth ? 'column' : 'row'}
      display={'flex'}
      gap={2}
    >
      <Paper elevation={2} sx={{ width: isFullWidth ? '100%' : '40%' }}>
        <FormTemplateTypesTable
          mode={FormTemplateEditorMode.default}
          templates={formTemplateTypes ?? []}
          loading={formTemplateTypesLoading}
        />
        <Box sx={{ mt: 4, mb: 4 }} />
        {selectedProject?.configuration?.samplesEnabled && (
          <FormTemplateTypesTable
            mode={FormTemplateEditorMode.sample}
            loading={sampleTemplateTypesLoading}
            templates={sampleTemplateTypes ?? []}
          />
        )}
      </Paper>

      <Paper elevation={2} sx={{ width: isFullWidth ? '100%' : '60%' }}>
        <VisitTemplateTable />
      </Paper>
    </Box>
  );
}
